import GhostContentAPI from '@tryghost/content-api';

const api = GhostContentAPI({
  url: 'https://www.lbstudio.sk/cms',
  key: 'f3bbc3786e92165f386ff23f56',
  version: 'v2',
});

const normalizePost = ({
  slug,
  title,
  feature_image: image,
  custom_excerpt: excerpt,
}) => ({
  slug,
  title,
  image,
  excerpt,
});

const formatTag = tag => `tag:${tag}`;

function getLocalizedTag(tag) {
  switch (tag) {
    case 'all':
      return '';

    case 'vsetko':
      return '';

    case 'clanky':
      return formatTag('articles');

    case 'podcasty':
      return formatTag('podcasts');

    case 'pripadovky':
      return formatTag('showcases');

    case 'videa':
      return formatTag('videos');

    case 'podujatia':
      return formatTag('events');

    default:
      return formatTag(tag);
  }
}

export const fetchPostsWithTag = async (tag, limit) => {
  const localizedTag = getLocalizedTag(tag);

  try {
    return (await api.posts.browse({
      limit,
      fields: 'slug,title,feature_image,url,custom_excerpt',
      // if 'formats' is not present, 'custom_excerpt' field will not be loaded
      formats: 'plaintext',
      filter: localizedTag,
    })).map(normalizePost);
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
    return [];
  }
};

export const fetchTotalPostsWithTag = async tag => {
  const localizedTag = getLocalizedTag(tag);

  try {
    return (await api.posts.browse({
      limit: 'all',
      fields: 'slug',
      filter: localizedTag,
    })).map(normalizePost);
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
    return [];
  }
};

export default null;



// WEBPACK FOOTER //
// ./src/scripts/modules/Insights/Posts/utils.js